import { consultarQuantasNotificacoesNaoLidas } from 'apps/notificacao/actions';
import { isAutenticadoComGovBr, isSessaoValida } from 'login/helper';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import { useAppThemeContext } from 'shared/contexts';
import history from '../../../history';
import Menu from '../menu';
import { getPlatformName } from 'platformImpl';
import { Hidden } from '@material-ui/core';
import { isLoggedIn } from "../../../shared/helper/infoUsuario";
import { getMenuPrincipalFromGestao, setIsMenuActive } from 'painel/actions';
import React, { useEffect, useMemo, useState } from 'react';
import UserInfo from './UserInfo';
import BtnEntrar from './BtnEntrar';
import useWindowSize, { isMobileDevice } from 'shared/helper/device';

const ToolbarDesktop = ({
  hasSession,
  hideUserOptions,
  notifications,
  fontSizeAction,
  handleKeyPressToggleFontSize,
  themeAction,
  handleKeyPressToggleTheme,
  title,
  description
}) => {

  return (
    <Hidden smDown>
    
      <button
        aria-label="Ir para página inicial"
        style={{ border: 'none', background: 'transparent', padding: 0, marginLeft: '16px' }}
      >
        <img
          id="logo_white_background"
          onClick={() => history.push("/")}
          src={require('../../../assets/img/inss-logo.webp')}
          alt={title} height="31px" width="44px" aria-hidden="true"
        />
      </button>      
      <div className="toolbar-title-container">
        <h1 className="toolbar-title">{title}</h1>
        <p className="toolbar-description">{description}</p>
      </div>
      <div className="toolbar-actions-desktop">
        <button
          aria-label="Alterar tamanho da fonte"
          title="Alterar Tamanho da Fonte"
          onClick={fontSizeAction}
          onKeyDown={handleKeyPressToggleFontSize}
          className="br-button circle toolbar-button"
        >
          <i className="fas fa-font toolbar-icon"></i>
        </button>

        <button
          aria-label="Alterar aparência da tela"
          title="Alterar Aparência da Tela"
          onClick={themeAction}
          onKeyDown={handleKeyPressToggleTheme}
          className="br-button circle toolbar-button"
        >
          <i className="fas fa-adjust toolbar-icon"></i>
        </button>

        {hasSession && !hideUserOptions && (
          <button
            aria-label="Consultar notificações"
            title="Consultar Notificações"
            onClick={() => history.push("/notificacoes")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                history.push("/notificacoes");
              }
            }}
            className="br-button circle toolbar-button"
          >
            <i className="fas fa-bell toolbar-icon"></i>
            {notifications > 0 && <span className="notification-pin"></span>}
          </button>
        )}

        {hasSession && !hideUserOptions ? (
          <UserInfo
            notifications={notifications}
          />
        ) : (
          !isAutenticadoComGovBr() && <BtnEntrar />
        )}
      </div>
 
    </Hidden>
  );
}

const ToolbarMobile = ({
  notifications,
  isRootPath,
  tituloPagina,
  title,
  hasSession
}) => {

  const dispatch = useDispatch();

  const handleNavigation = (path) => {
    history.push(path);
    dispatch(setIsMenuActive(false));
  };

  return (
    <Hidden mdUp>
      <div className="toolbar-mobile-container">
        <div className="toolbar-mobile-left">
          <p className="toolbar-mobile-title">
            {tituloPagina || title}
          </p>
        </div>
      </div>
      <div style={{ display: "flex" }}>
      {hasSession && (
        <>
          {isRootPath() && (
            <>
              <button
                aria-label="Buscar serviços"
                className="toolbar-mobile-button"
                onClick={() => handleNavigation("/buscar-servico")}
              >
                <i className="fas fa-search toolbar-mobile-icon"></i>
              </button>

              <button
                aria-label="Acessar notificações"
                className="toolbar-mobile-button"
                onClick={() => handleNavigation("/notificacoes")}
              >
                <i className="fas fa-bell toolbar-mobile-icon"></i>
                {notifications > 0 && <div className="avatar-notificacao"></div>}
              </button>
            </>
          )}

          <button
            aria-label="Configurações do perfil"
            className="toolbar-mobile-button"
            onClick={() => handleNavigation("/configuracoes")}
          >
            <i className="fas fa-user-circle toolbar-mobile-icon"></i>
          </button>
        </>
      )}
    </div>

    </Hidden>
  );
};

const MIToolbar = () => {

  const dispatch = useDispatch();
  const { toggleTheme } = useAppThemeContext();
  const title = "Meu INSS";
  const description = "Instituto Nacional do Seguro Social";
  const pessoaCnis = useSelector(state => state.session.pessoaCnis);
  const usuario = useSelector(state => state.session.usuario);
  const notificacoes = useSelector(state => state.notificacoes.qtdNaoLida);
  const gestaoIndisponivel = useSelector(state => state.app.gestaoIndisponivel);
  const tituloPagina = useSelector(state => state.app.tituloPagina);
  const dadosDivergentes = useSelector(state => state.session.dadosDivergentes);
  const dadosInscricao = useSelector(state => state.session.dadosInscricao);
  const loadingBasicInfo = useSelector(state => state.session.loadingBasicInfo);
  const [requisitouNotificacoes, setRequisitouNotificacoes] = useState(false);
  const location = useLocation();
  const { width, height } = useWindowSize();

  const hasSession = useMemo(() => {
    return isSessaoValida();
  }, [ dadosDivergentes, dadosInscricao])

  const showSideMenuEeUserInfo = useMemo(() => {
    return !gestaoIndisponivel && hasSession && !loadingBasicInfo;
  }, [gestaoIndisponivel, hasSession, loadingBasicInfo]);

  useEffect(() => {
    if (usuario && usuario.cpf && !requisitouNotificacoes) {
      consultarQuantasNotificacoesNaoLidas();
      setRequisitouNotificacoes(true);
    }
  }, [usuario]);

  const handleKeyPressToggleTheme = (event) => {
    if (event.key === 'Enter') {
      toggleTheme();
    }
  }

  const fontSizeAction = () => {
    history.push("/aberto/tamanho-fonte");
  }

  const handleKeyPressToggleFontSize = (event, value) => {
    if (event.key === 'Enter') {
      fontSizeAction(value);
    }
  }

  const isRootPath = () => {
    return location.pathname === "/" || location.pathname.startsWith("#/?origem-click=");
  }

  useEffect(() => {
    dispatch(getMenuPrincipalFromGestao());
  }, []);
  
  const notifications = useMemo(() => {
    if (pessoaCnis && pessoaCnis !== "erro" && pessoaCnis !== "obito"
      && pessoaCnis !== "not found" && notificacoes) {
      return `${notificacoes}`.length > 1 ? "9+" : notificacoes;
    } else {
      return 0;
    }
  }, [pessoaCnis, notificacoes]);


  return (
    <div className="govbr">
      <header className='toolbar'>
        {showSideMenuEeUserInfo ?
          <Menu />
          :
          <>
          {(!isLoggedIn() && isMobileDevice(width, 959)) ? 
          <button
            className="br-button circle toolbar-button-back"
            type="button"
            aria-label="Voltar"
            onClick={() => history.goBack()}
          >
            <i style={{fontSize: '1.2em'}} className="fas fa-arrow-left" ></i>
          </button> : ''}
          </>
        }

        <ToolbarDesktop
          title={title}
          description={description}
          hasSession={hasSession}
          hideUserOptions={!showSideMenuEeUserInfo}
          notifications={notifications}
          fontSizeAction={fontSizeAction}
          handleKeyPressToggleFontSize={handleKeyPressToggleFontSize}
          themeAction={toggleTheme}
          handleKeyPressToggleTheme={handleKeyPressToggleTheme}
        />

        <ToolbarMobile
          tituloPagina={tituloPagina}
          title={title}
          notifications={notifications}
          isRootPath={isRootPath}
          hasSession={hasSession}
        />
      </header>
    </div>
  )
};

export default MIToolbar;